import axios from './axiosConfig';

export function saveQuizFeedbacks(id, data) {
   return axios.put('/api/v1/quiz/' + id, data)
        .then((response) => {
            // handle success
            return response.data;
        })
        .catch((error) => {
            // handle error
           return error;
        });
}

export function saveFeedbacksForm(data) {
     return axios.post('/api/v1/feedback', data)
        .then((response) => {
            return response.data;
        }).catch((error) => {
             // handle error
             return error;
         });
}